/* eslint-disable react/jsx-handler-names */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import _get from 'lodash/get';

import { bem } from 'helpers/class-name';
import Message from 'components/Message';
import { DropdownPropTypes } from './Dropdown';
import PillMenu from './PillMenu';
import './MultiSelectPillMenu.scss';

const messages = defineMessages({
  selectAll: {
    id: 'dropdown.multiselect-pillmenu.select-all',
    defaultMessage: 'Select all',
  },
});

const { element } = bem('multi-select-pill-menu');

const Label = ({ item, isSelected, getText, onChange, isDisabledItem }) => {
  const isDisabled = isDisabledItem && isDisabledItem(item);
  return (
    <label
      role="presentation"
      className={element('label', { disabled: isDisabled })}
      onClick={event => event.stopPropagation()}>
      <input
        type="checkbox"
        checked={isSelected(item)}
        onChange={event => onChange(event, item)}
        className={element('input')}
        disabled={isDisabled}
      />
      {getText(item)}
    </label>
  );
};

Label.propTypes = {
  ...DropdownPropTypes,
  isDisabledItem: PropTypes.func,
  onChange: PropTypes.func,
};

class MultiSelectPillMenu extends Component {
  changeAllItem = { isChangeAllItem: true };

  static propTypes = {
    getId: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    getKey: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    getText: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])),
    onChange: PropTypes.func,
    selectedItemsIdsSet: PropTypes.instanceOf(Set),
  };

  handleChange = (event, item) => {
    const { onChange, items, selectedItemsIdsSet } = this.props;
    const isChecked = event.target.checked;
    const { isChangeAllItem } = item;

    let ids;
    if (isChangeAllItem) {
      if (isChecked) {
        ids = items.map(this.getId);
      } else {
        ids = [];
      }
    } else {
      const id = this.getId(item);
      if (isChecked) {
        selectedItemsIdsSet.add(id);
      } else {
        selectedItemsIdsSet.delete(id);
      }
      ids = Array.from(selectedItemsIdsSet);
    }

    onChange(ids);
  };

  getKey = item => {
    const { getKey } = this.props;

    if (!item) {
      return '';
    }

    if (item.isChangeAllItem) {
      return 'changeAllItem';
    }

    return typeof getKey === 'string' ? _get(item, getKey, Date.now()) : getKey(item);
  };

  getText = item => {
    const { getText } = this.props;

    if (!item) {
      return '';
    }

    if (item.isChangeAllItem) {
      return <Message message={messages.selectAll} />;
    }

    return typeof getText === 'string' ? _get(item, getText, '') : getText(item);
  };

  getId = item => {
    const { getId } = this.props;
    return typeof getId === 'string' ? _get(item, getId, '') : getId(item);
  };

  isSelected = item => {
    const { items, selectedItemsIdsSet } = this.props;
    const { isChangeAllItem } = item;

    if (isChangeAllItem) {
      return items.length === selectedItemsIdsSet.size;
    }

    const id = this.getId(item);
    return selectedItemsIdsSet.has(id);
  };

  renderAsActive = () => {
    const { items, selectedItemsIdsSet } = this.props;
    return selectedItemsIdsSet.size !== 0 && !(items.length === selectedItemsIdsSet.size);
  };

  render() {
    const { items, selectedItemsIdsSet, ...rest } = this.props;

    return (
      <PillMenu
        {...rest}
        Item={Label}
        noCloseOnSelect
        items={items.length ? [this.changeAllItem, ...items] : []}
        getKey={this.getKey}
        getText={this.getText}
        getId={this.getId}
        isSelected={this.isSelected}
        renderAsActive={() => this.renderAsActive()}
        onChange={this.handleChange}
      />
    );
  }
}

export default MultiSelectPillMenu;
